import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { Router, NavigationEnd, ActivatedRoute, Data } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { TablerIconsModule } from 'angular-tabler-icons';
import { LocalizationPipe } from '../../../../pipe/localization-pipe';
import { LocalizationService } from '../../../../services/localizationService';

@Component({
    selector: 'app-breadcrumb',
    standalone: true,
    imports: [RouterModule, TablerIconsModule, LocalizationPipe],
    templateUrl: './breadcrumb.component.html',
    styleUrls: []
})
export class AppBreadcrumbComponent {
  // @Input() layout;
  pageInfo: Data | any = Object.create(null);
  myurl: any = this.router.url.slice(1).split('/');
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private localizationService: LocalizationService
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        })
      )
      .pipe(filter((route) => route.outlet === 'primary'))
      .pipe(mergeMap((route) => route.data))
      // tslint:disable-next-line - Disables all
      .subscribe((event) => {
        // tslint:disable-next-line - Disables all
        let title = event['title'];
        if (title) {
          title = this.localizationService.getLocalizationValue(title);
        }
        this.titleService.setTitle(title + ' - BilgeBot');
        this.pageInfo = event;
      });
  }
}
